import {
  IMPACT_LEVELS,
  URGENCY_LEVELS,
  getPriorityMeta,
} from '../../utils/priorityMatrix'

const labelOf = (levels, value) =>
  levels.find((l) => l.value === Number(value))?.label || '—'

/**
 * Clasificación del ticket como filas clave → valor del panel de propiedades:
 * la Prioridad derivada (matriz Impacto × Urgencia) y sus dos ejes.
 *
 * @component
 * @param {Object} props
 * @param {Object} props.ticket - Ticket con impact, urgency, priorityId.
 * @returns {JSX.Element|null}
 */
const TicketClassification = ({ ticket }) => {
  if (!ticket) return null

  const priority = getPriorityMeta(ticket.priorityId)

  return (
    <>
      <div className="vt-prop">
        <span className="vt-prop-label">Prioridad</span>
        <span
          className="tc-badge"
          style={{ color: priority.color, background: `${priority.color}1a` }}
        >
          <i className="fa-solid fa-circle" style={{ fontSize: '6px' }} />
          {priority.label}
        </span>
      </div>
      <div className="vt-prop">
        <span className="vt-prop-label">Impacto / Urgencia</span>
        <span className="vt-prop-value">
          {labelOf(IMPACT_LEVELS, ticket.impact)}
          <span className="tc-sep">/</span>
          {labelOf(URGENCY_LEVELS, ticket.urgency)}
        </span>
      </div>

      <style>{`
        .tc-badge {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          font-size: 0.72rem;
          font-weight: 600;
          padding: 2px 9px;
          border-radius: 99px;
          white-space: nowrap;
        }
        .tc-sep {
          margin: 0 5px;
          color: var(--gm-text-faint);
          font-weight: 400;
        }
      `}</style>
    </>
  )
}

export default TicketClassification
